module.exports = __webpack_public_path__ + "img/prizeThree.505ce382.png";